(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sport/sport-common/assets/javascripts/sport-utils.js') >= 0) return;  svs.modules.push('/components/sport/sport-common/assets/javascripts/sport-utils.js'); 'use strict';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

svs.sport = svs.sport || {};
svs.sport.sport_common = svs.sport.sport_common || {};
var HIGHLIGHTED_LEAGUES; 

if (svs.isServer) {
  HIGHLIGHTED_LEAGUES = require('./sport-constants.es6');
} else {
  HIGHLIGHTED_LEAGUES = svs.sport.sport_common.constants.HIGHLIGHTED_LEAGUES;
}


function getGrasrotenMessage() {
  return getSponsorships().then(function () {
    var receivers = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    return svs.sport.sport_common.formatMessage(receivers.filter(function (receiver) {
      return !receiver.forcedInvalidation;
    }));
  }).catch(function (error) {
    svs.sport_common_logger.error('Failed to fetch sponsorship, error: ', error);
    return '';
  });
}

function getGrasrotenMessageForDialogOrToaster() {
  var grasroten = {
    hasSponsorship: false
  };
  return getSponsorships().then(function (receivers) {
    if (receivers && receivers.length) {
      var shortNames = receivers.map(function (receiver) {
        return receiver.shortname;
      }); 

      var uniqueShortNames = [];
      shortNames.forEach(function (name) {
        if (uniqueShortNames.indexOf(name) === -1) {
          uniqueShortNames.push(name);
        }
      }); 

      grasroten.thankYouMessage = "<div>".concat(shortNames.length < 2 ? shortNames[0] : "".concat(shortNames.slice(0, -1).join(', '), " och ").concat(shortNames.slice(-1)), " tackar f\xF6r ditt st\xF6d via Gr\xE4sroten!</div>");
      grasroten.hasSponsorship = true;
    }

    return grasroten;
  }).catch(function (error) {
    svs.sport_common_logger.error('Failed to fetch sponsorship, error: ', error);
    return {};
  });
}


function getContextualGrasrotenDialog() {
  return getGrasrotenMessage().then(function (msg) {
    var dialog; 

    if (msg && msg.indexOf('Du vet väl att')) {
      dialog = new svs.components.dialog.Confirm({
        area: svs.components.dialog.area.TOASTER,
        branding: svs.components.dialog.branding.SPORT,
        icon: 'favorites',
        title: 'Stötta dina favoritföreningar med Gräsroten',
        message: [{
          type: svs.components.dialog.message.TEXT,
          text: 'Välj upp till tre favoritföreningar som får ditt stöd varje gång du spelar.'
        }],
        actions: [{
          title: 'Påminn mig senare'
        }, {
          title: 'Välj favoriter',
          callback: function callback() {
            location.href = svs.utils.urlMapping.get('grassrootsHome');
          }
        }]
      });
    } else {
      dialog = new svs.components.dialog.Confirm({
        branding: svs.components.dialog.branding.SPORT,
        icon: 'thumbs-up',
        title: msg.split('</br>').join(''),
        actions: [{
          title: 'OK'
        }]
      });
    }

    return dialog;
  }).catch(function (error) {
    svs.sport_common_logger.error('Failed to create Grasroten dialog, error: ', error);
    return undefined;
  });
}


function formatMessage(receivers) {
  var message = '';

  if (receivers && receivers.length) {
    var shortNames = receivers.map(function (receiver) {
      return receiver.shortname;
    });
    message += "<div>".concat(shortNames.length < 2 ? shortNames[0] : "".concat(shortNames.slice(0, -1).join(', '), " och ").concat(shortNames.slice(-1)), " tackar f\xF6r ditt st\xF6d via Gr\xE4sroten!</div></br>");
  } else {
    message += "<div>Du vet v\xE4l att du kan st\xF6tta din favoritf\xF6rening varje g\xE5ng du spelar.</div><div><a href=\"".concat(svs.utils.urlMapping.get('grassrootsHome'), "\" class=\"alert-text-link\">V\xE4lj f\xF6reningar h\xE4r.</a></div></br>");
  }

  return message;
}


function checkExclusionOnVertical() {
  if (!svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER)) {
    return;
  }

  svs.accountservices.player_exclusions.hasExclusionOnVertical('sport', function (data) {
    if (data && data.hasExclusions) {
      svs.sport.sport_common.showErrorDialog('Du har en aktiv spelpaus', data.exclusionInfo);
    }
  });
}

function isHighlightedLeague(leagueId) {
  var isHighlightedLeague = false;
  HIGHLIGHTED_LEAGUES.forEach(function (element) {
    if (element === leagueId) {
      isHighlightedLeague = true;
    }
  });
  return isHighlightedLeague;
}


function getSponsorships() {
  var deferred = $.Deferred();
  svs.core.jupiter.call({
    method: 'GET',
    path: '/player/sponsorship/receiverselection?active=true'
  }, function (data) {
    try {
      deferred.resolve(data.receivers);
    } catch (error) {
      deferred.reject(error);
    }
  }, function (error) {
    deferred.reject(error);
  });
  return deferred.promise();
}

function showErrorDialog(title, message) {
  var dialogConfig = {
    branding: svs.components.dialog.branding.SPORT,
    icon: 'help-2',
    type: svs.components.dialog.type.ERROR,
    actions: [{
      title: 'OK'
    }]
  };

  if (title) {
    dialogConfig.title = title;
  } else {
    dialogConfig.title = 'Nu gick något fel';
  }

  if (message) {
    dialogConfig.message = [{
      type: svs.components.dialog.message.TEXT,
      text: message
    }];
  }

  svs.components.dialog.api.add(new svs.components.dialog.Confirm(dialogConfig));
}

var exportThis = {
  isHighlightedLeague: isHighlightedLeague,
  checkExclusionOnVertical: checkExclusionOnVertical,
  formatMessage: formatMessage,
  getGrasrotenMessage: getGrasrotenMessage,
  getContextualGrasrotenDialog: getContextualGrasrotenDialog,
  getGrasrotenMessageForDialogOrToaster: getGrasrotenMessageForDialogOrToaster,
  showErrorDialog: showErrorDialog
};

if (svs.isServer) {
  module.exports = exportThis;
} else {
  svs.sport.sport_common = _objectSpread({}, svs.sport.sport_common, {}, exportThis);
}
 })(window);